export const POLICY_EFFECTIVE_DATE = "To be updated";

export const PRIVACY_POLICY_ITEMS = [
  {
    title: "Information We Collect:",
    body:
      "Personal info, contact details, location data, vehicle details, property details, transaction and payout data.",
  },
  {
    title: "How We Use Information:",
    body:
      "To process bookings, payments, refunds, payouts, validation alerts, customer support, and service improvements.",
  },
  {
    title: "Wallet & Refund Data:",
    body:
      "Wallet and refund data is stored for dispute resolution and financial reconciliation.",
  },
  {
    title: "Service Validation Data:",
    body:
      "We send essential notifications for service start, status, and completion. These cannot be opted out of during active bookings.",
  },
  {
    title: "Assistant Payout Data:",
    body:
      "We process payout data including payment splits, commission deductions, and satisfaction confirmations for settlement.",
  },
  {
    title: "Data Sharing:",
    body:
      "Data may be shared with Assistants, Hosts, or payment providers for service delivery. Pulo does not sell personal data.",
  },
  {
    title: "Data Security:",
    body:
      "We take reasonable steps to protect information but cannot guarantee absolute security.",
  },
  {
    title: "User Rights:",
    body: "Users may request access, correction, or deletion of data.",
  },
  {
    title: "Data Retention:",
    body: "Data is retained as long as needed for service delivery or legal compliance.",
  },
  {
    title: "Policy Updates:",
    body: "Policy may be updated. Continued use constitutes acceptance.",
  },
];

export const TERMS_CONDITION_ITEMS = [
  {
    title: "Eligibility",
    body: "You must be at least 18 years old to use Pulo.",
  },
  {
    title: "Platform Overview",
    body:
      "Pulo is a digital platform that connects users with independent travel assistants (Pulo Assistants) and accommodation providers (Hosts). Pulo does not directly provide transportation or accommodation services.",
  },
  {
    title: "User Accounts",
    body:
      "Users must provide accurate and up-to-date information and are responsible for their account security.",
  },
  {
    title: "Bookings & Payments",
    body:
      "Users are required to pay 100% of the service fee at the point of booking. Payment confirms scheduling and is held in escrow until service completion.",
  },
  {
    title: "Refund & Dispute Resolution",
    body:
      "Users may request refunds which will be reviewed by Customer Support and may result in full, partial, or no refund.",
  },
  {
    title: "Wallet System",
    body:
      "Wallet credits may be issued from refunds or promotions. Wallet credits are non-withdrawable, non-transferable, and cannot be funded by users.",
  },
  {
    title: "Service Validation Alerts",
    body:
      "Users receive alerts near service start to validate that the assistant has begun work. Validation affects refund eligibility.",
  },
  {
    title: "Assistant Payout Structure",
    body:
      "Pulo Assistants receive 50% payout once the service starts. The remaining 50% is released after service completion and customer satisfaction confirmation.",
  },
  {
    title: "Revenue Model",
    body: "Pulo charges a 30% commission on every booking before payouts to assistants.",
  },
  {
    title: "Independent Providers",
    body: "Assistants and Hosts are independent contractors, not employees of Pulo.",
  },
  {
    title: "Safety & Liability",
    body:
      "Pulo is not responsible for actions or omissions of independent providers or users.",
  },
  {
    title: "Account Suspension",
    body: "Pulo may suspend or terminate accounts for violations.",
  },
  {
    title: "Modifications",
    body: "Terms may be updated. Continued use constitutes acceptance.",
  },
  {
    title: "Governing Law",
    body: "These Terms are governed by the laws of the Federal Republic of Nigeria.",
  },
];
